import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useState,
} from 'react';

export const AccordionContext = createContext({
  expanded: {} as boolean,
  setExpanded: {} as Dispatch<SetStateAction<boolean>>,
});

export const AccordionProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value?: boolean;
}) => {
  const [expanded, setExpanded] = useState<boolean>(
    value || (false as boolean)
  );

  return (
    <AccordionContext.Provider value={{ expanded, setExpanded }}>
      {children}
    </AccordionContext.Provider>
  );
};
